<template>
  <ul
    v-show="showList"
    ref="ul"
  >
    <li
      v-for="(item, index) in list"
      ref="items"
      tabindex="-1"
      :key="index"
      @click="select(item)"
      @mouseover="emitBusiness(item)"
      @keyup="onKeyUp"
    >
      <b v-if="returnList && item.city">{{ `${item.postal_code} - ${item.city.label}` }}</b>
      <span>
        {{ `${item.label} ${item.distance || item.distance === 0 ? `(${item.distance.toString()} Km)` : item.postal_code}`.trim() }}
        <booking-one-way-icon v-if="item.is_oneway && !returnList && oneWay" />
      </span>
    </li>
  </ul>
</template>

<script>
import { mapState } from 'vuex'
import BookingOneWayIcon from './BookingOneWayIcon'

export default {
  name: 'BookingInputList',
  props: {
    list: {
      type: [Array, Object],
      default: () => [],
    },
    returnList: {
      type: Boolean,
      required: true,
    },
    triggerFocusList: {
      type: Boolean,
      default: false,
    },
    showingBusiness: {
      type: undefined,
      default: false,
    },
  },
  components: {
    BookingOneWayIcon,
  },
  data() {
    return {
      focusedIndex: null,
    }
  },
  computed: {
    ...mapState({
      oneWay: (state) => state.booking.oneWay,
      pickUpBusiness: (state) => state.booking.pickUp.business,
      pickUpDate: (state) => state.booking.pickUp.date,
      pickUpTime: (state) => state.booking.pickUp.time,
      dropBusiness: (state) => state.booking.drop.business,
      dropDate: (state) => state.booking.drop.Date,
    }),
    showList() {
      if (this.returnList && !this.oneWay) {
        return false
      }
      return this.list.length > 0
    },
  },
  watch: {
    async triggerFocusList() {
      if (!this.$refs.items[0]) {
        return
      }
      this.focusAtIndex(0)
    },
  },
  created() {
    window.addEventListener('keydown', this.preventScroll)
  },
  destroyed() {
    window.removeEventListener('keydown', this.preventScroll)
  },
  methods: {
    select(selectedItem) {
      // hide the dropdown list
      // this.isListVisible = false;
      // emit to parent
      this.$emit('selected', selectedItem)
    },
    emitBusiness(business) {
      // get the value from the business, save it to the store so we can use it in the popin
      this.$emit('hoveredBusiness', business)
    },
    onKeyUp(ev) {
      ev.preventDefault()
      const nextItem = ev.key === 'ArrowDown'
      const prevItem = ev.key === 'ArrowUp'
      const enter = ev.key === 'Enter'

      if (prevItem) {
        return this.focusPrevItem()
      }

      if (nextItem) {
        return this.focusNextItem()
      }
      if (enter) {
        this.select(this.list[this.focusedIndex])
      }
      if (this.showingBusiness) {
        return
      }
      return this.$emit('focusinput')
      // if (focusList)
    },
    focusPrevItem() {
      if (this.focusedIndex === 0) {
        return this.$emit('focusinput')
      }
      this.focusAtIndex(this.focusedIndex - 1)
    },
    focusNextItem() {
      if (this.focusedIndex >= (this.$refs.length - 1)) {
        return
      }
      this.focusAtIndex(this.focusedIndex + 1)
    },
    focusAtIndex(index) {
      if (!this.$refs.items[index]) {
        return
      }
      this.$refs.items[index].focus()
      this.focusedIndex = index
    },
    preventScroll(ev) {
      if (!(ev.key !== 'ArrowDown' || ev.key !== 'ArrowUp')) {
        return
      }
      if (ev.target.parentNode === this.$refs.ul) {
        ev.preventDefault()
      }
    },
  },
}
</script>

<style scoped lang="scss">

ul {
  //   background: #fff;
  background-color: $lt-gray;
  color: #000;
  display: flex;
  flex: 1;
  flex-direction: column;
  left: 0;
  max-height: 350px;
  overflow-y: scroll;
  position: absolute;
  right: 0;
  top: 36px;
  z-index: 3;
}

li {
  @include shadow(inset 0 -1px 0 0 rgba(224, 224, 224, 1));
  @include font-size(12px);

  background-color: #fff;
  cursor: pointer;
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: 11px 20px;

  &:focus,
  &:hover {
    background-color: $lt-gray;
  }
}

b {
  font-weight: 900;
  line-height: 12px;
}

span {
  display: flex;
  justify-content: space-between;
  position: relative;
}
</style>
